$(document).on "ready", ->
    Flagship.init()

Flagship =

    sharePopup: (href) ->
      w = 600
      h = 300
      left = (screen.width / 2) - (w / 2)
      top = (screen.height / 2) - (h / 2)
      shareWindow = window.open(
          href
          "Flagship"
          "location=1,status=1,scrollbars=1,
          width=" + w + ",height=" + h + ",top=" + top + ",left=" + left
      )
      return false

    styleMaps: ->
        map = smartMap.map['smartmap-mapcanvas-1']
        mapStyles = [ {
            featureType: 'all'
            elementType: 'all'
            stylers: [
                { saturation: -100 },
                { lightness: 30 }
            ]
        } ]
        map.setOptions styles: mapStyles

        google.maps.event.addDomListener window, 'resize', ->
            center = map.getCenter()
            google.maps.event.trigger map, 'resize'
            map.setCenter center

    submitForm: ->
        # Remove any existing error messages from previous attempts
        $this = $(".js-contact-form")
        $this.find('label.error').remove()
        # Create fullName for sending "from name"
        firstName = $this.find("input[name='message[First Name]']").val()
        lastName = $this.find("input[name='message[Last Name]']").val()
        fullName = ""
        if firstName.length > 0
            fullName = firstName
        if lastName.length > 0
            if fullName.length > 0
                fullName = fullName + " #{lastName}"
            else
                fullName = lastName
        # Add fromName
        $("#fromName").val fullName
        # Add name to email subject
        if fullName.length > 0
            $contactSubject = $(".js-contact-subject")
            $baseSubject = $contactSubject.data 'base-subject'
            $contactSubject.val($baseSubject + " from #{fullName}")
        # Get the post data
        formData = new FormData($this[0])
        # Send it to the server
        $.ajax
            url: '/',
            data: formData,
            type: 'POST',
            async: false,
            cache: false,
            contentType: false,
            processData: false,
            success: (response) ->
                if response.success
                    $(".js-thanks").fadeIn()
                    $this[0].reset()
            error: (response) ->
                # response.error will be an object containing any validation errors that occurred, indexed by field name
                for fieldName of response.error
                    message = response.error[fieldName][0]
                    $("##{fieldName}").after("<label class='error'>#{message}</label>")

    masonryReload: ->
      $grid = undefined
      # trigger masonry on document ready

      triggerMasonry = ->
        # don't proceed if $grid has not been selected
        if !$grid
          return
        # init Masonry
        $grid.masonry {}
        return

      $ ->
        $grid = $(".js-grid")
        triggerMasonry()
        return

      # trigger masonry when fonts have loaded
      Typekit.load
        active: triggerMasonry
        inactive: triggerMasonry

    setHeroHeight: ->
        # Set min-height of homepage header
        windowHeight = $(window).height()
        vh = 98
        fullHeight = windowHeight*(vh/100)
        placeholderHeight = $(".header-placeholder").height()
        announcementHeight = 0
        if $(".announcement").length
            announcementHeight = $(".announcement").height()
        offsetHeight = placeholderHeight + announcementHeight
        $('.page-home .page_header').css 'min-height', fullHeight - offsetHeight

    onLoad: ->
        Flagship.onResize()
        Flagship.masonryReload()
        Flagship.setHeroHeight()

        # Video
        $coverVideo = $(".covervid-video")
        if $coverVideo.length
            $coverVideo.coverVid 1280, 720
            # Video full screen fix
            $(window).trigger "resize"
            $coverVideo.css("opacity", "1")

        if $(".smartmap-mapcanvas").length
            Flagship.styleMaps()

    onResize: ->

    init: ->
        Flagship.onLoad()
        $(window).resize ->
            Flagship.onResize()

        PointerEventsPolyfill.initialize {}

        # Hero Height for Mobile Devices
        if typeof window.orientation != 'undefined'
          query = window.matchMedia('(orientation:landscape)')
          changeHeight = (query) ->
            if query.matches
              Flagship.setHeroHeight()
            else
              Flagship.setHeroHeight()
            return
          query.addListener changeHeight
        else
          $(window).resize ->
            Flagship.setHeroHeight()
            return

        $(".js-grid").masonry
            columnWidth: ".js-grid-sizer"
            gutter: ".js-gutter-sizer"
            itemSelector: ".js-grid-item"
            percentPosition: true
            transitionDuration: 0

        # Update city cookie
        $("body").on "change", ".js-toggle_city", ->
            chosenCity = $(this).val()
            $(".js-toggle_name").text chosenCity
            $("body").addClass "is-reloading"
            # Update Current_City cookie
            Cookies.set "Current_City", chosenCity, expires: 1
            # Remove Current_Location cookie so craft searches nearest location on next page load
            Cookies.remove "Current_Location"
            if $("body").hasClass("page-home")
                window.location.href = window.location.href # Goes to top of page after page load
            else
                window.location.href = "/locations"

        # Update location cookie
        $("body").on "change", ".js-toggle_location", ->
            $this = $(this)
            chosenLocation = $this.find("option:selected").data "location"
            Cookies.set "Current_Location", chosenLocation, expires: 1
            url = $this.val()
            if url
                window.location = url

        # Make share links pop up in new windows
        $(".js-share-popup").click (event) ->
            event.preventDefault()
            Flagship.sharePopup $(this).attr "href"

        # Toggle navigation
        $(".js-nav_toggle").click ->
            $(".nav").toggleClass "nav--open", ""
            $("body").toggleClass "noscroll", ""
            setTimeout (->
                $(".nav").toggleClass "nav--animate", ""
            ), 50

        $(".js-gallery").magnificPopup
            type: "image"
            gallery: enabled: true
            preloader: true

        $(".js-location_modal").magnificPopup
            type: "inline"
            mainClass: "dark_background"

        $(".js-location_modal-close").click ->
            $.magnificPopup.close()

        # Retrieve data attribute to set mailer recipients
        $(".js-location-select, .js-experience-select").change ->
            recipientLocation = $(".js-location-select").find("option:selected").val()
            recipientExperience = $(".js-experience-select").find("option:selected").data "experience"
            recipients = $(".js-recipients").find("[data-name='#{recipientLocation}']").data "#{recipientExperience}"
            $(".js-to-email").val "#{recipients}"
            if recipientExperience == "negative"
                $(".js-experience-negative").show()
            else
                $(".js-experience-negative").hide()

        # Retrieve data attribute to set mailer recipients for BYOSB
        $(".js-byosb-select").change ->
            recipients = $(".js-byosb-select").find("option:selected").data 'recipients'
            if recipients
                $(".js-to-email").val "#{recipients}"
            else
                $(".js-to-email").val ""

        # Show nearest location first on locations page
        $firstLocation = $(".locations .current_city").siblings(".locations-city").eq(0)
        $(".locations .current_city").insertBefore $firstLocation

        # Slider
        $(".slider").each ->
            $slider_container = $(this)
            $slider = $slider_container.find ".js-slider"
            $slider_pager = $slider_container.find ".js-slider-pager"

            updateSlideControls = ->
                # Add next/previous links over next/previous slides
                $current_slide = $slider.find(".owl-item.center")
                $slider.find(".owl-item").removeClass "owl-item-prev"
                $slider.find(".owl-item").removeClass "owl-item-next"
                $current_slide.prev().addClass "owl-item-prev"
                $current_slide.next().addClass "owl-item-next"

            $slider.imagesLoaded ->
                $slider.owlCarousel
                    autoplay: true
                    center: true
                    dotsContainer: $slider_pager
                    items: 1
                    loop: true
                    margin: 30
                    responsive: 1100:
                        items: 2
                        autoWidth: false
                    onInitialized: updateSlideControls
                    onTranslated: updateSlideControls

                # Go to the next slide item
                $slider_container.on "click", ".js-slider-next, .owl-item-next", (event) ->
                    event.preventDefault()
                    $slider.trigger "next.owl.carousel"
                # Go to the previous slide item
                $slider_container.on "click", ".js-slider-prev, .owl-item-prev", (event) ->
                    event.preventDefault()
                    $slider.trigger "prev.owl.carousel"

        navWaypoint = new Waypoint(
            element: $(".header-placeholder")
            handler: (direction) ->
                $("body").toggleClass "is-scrolled", ""
            offset: -50)

        if $(".page-home").length
            homepageHeaderWaypoint = new Waypoint(
                element: $(".header-placeholder")
                handler: (direction) ->
                    $(".page-home .header").toggleClass "header--dark", ""
                offset: -50)

            homepageSummaryWaypoint = new Waypoint(
                element: $(".page-home .summary")
                handler: (direction) ->
                    $(".page-home .header").toggleClass "header--light", ""
                offset: 80)

        # Populate modal with footer's current location content
        $(".footer .current_locations").clone().appendTo(".js-append_locations")

        # Move header logo on homepage
        $(".page-home .mobile_header").detach().appendTo(".js-append_logo")

        # Contact form validation
        $(".js-contact-form").validate
            submitHandler: (form, event) ->
                event.preventDefault()
                Flagship.submitForm()

        # Append custom text to reservations widgets
        $(".js-open_reservation").click (event) ->
            sn.showReservationSelector(this);
            setTimeout (->
                $("#sn-reservationContainer").after('<p style="margin-top: 15px; padding: 0 5px; font-style: italic; font-size: 14px;">If your party size is larger than what’s available online, please call the restaurant to make your reservation.</p><p style="margin-top: 10px; padding: 0 5px; font-style: italic; font-size: 14px;">Patio tables cannot be reserved and are available on a first-come, first-served basis.</p>')
                console.log('opened reservation')
            ), 100

class Flagship.Controller
